import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('Game Development');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <PageHeading
        title='Game Development'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={'Game Development'}
      />

      <Spacing lg='120' md='60' />

      {/* Introduction to Game Development */}
      <Div className="container">
        <SectionHeading
          title='Immersive Game Development Services'
          subtitle='Crafting Experiences That Captivate Players'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          At Dappster Studio, we design and develop immersive games that entertain, engage, and elevate your brand. From indie games to full-scale productions, our expert team brings your vision to life with stunning graphics, intuitive gameplay, and engaging storylines.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          Whether you're launching a mobile game, web-based experience, or blockchain-integrated play-to-earn platform, we deliver scalable solutions using technologies like Unity, Unreal Engine, and WebGL.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Game Development Services */}
      <Div className="container">
        <SectionHeading
          title='Our Game Development Services'
          subtitle='End-to-End Game Design and Engineering'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_1.svg' title='Mobile Game Development' subtitle='iOS and Android games with engaging UI/UX and optimized performance.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_2.svg' title='Web-Based Games' subtitle='Cross-platform browser games built with HTML5, Phaser, and WebGL.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_3.svg' title='Unity & Unreal Development' subtitle='High-performance 2D/3D games using powerful engines like Unity and Unreal.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_4.svg' title='AR/VR Games' subtitle='Immersive experiences for virtual and augmented reality platforms.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_5.svg' title='Blockchain Game Development' subtitle='Play-to-earn models, NFTs, and smart contract integration for Web3 gaming.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/service_icon_6.svg' title='Game UI/UX Design' subtitle='Pixel-perfect interfaces that enhance gameplay and user experience.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-6">
            <IconBox icon='/images/icons/service_icon_7.svg' title='Multiplayer Game Development' subtitle='Real-time and turn-based multiplayer systems for engaging social play.' />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-6">
            <IconBox icon='/images/icons/service_icon_8.svg' title='Game Maintenance & Updates' subtitle='Post-launch support, bug fixing, content updates, and scalability.' />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Industries for Game Development */}
      <Div className="container">
        <SectionHeading
          title='Game Development for All Sectors'
          subtitle='Gaming Solutions Across Industries'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/media-icon.svg' title='Entertainment & Media' subtitle='Interactive storytelling and casual gaming experiences.' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/education-icon.svg' title='Education' subtitle='Gamified learning tools and e-learning experiences.' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/healthcare-icon.svg' title='Healthcare & Wellness' subtitle='Therapeutic games for physical and mental well-being.' />
          </Div>
        </Div>
        <Div className="row mt-lg-5" >
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/ad-icon.svg' title='Marketing & Advertising' subtitle='Branded games and gamified campaigns for engagement.' />
          </Div>
          <Div className="col-lg-4">
            <IconBox icon='/images/icons/blockchain-icon.svg' title='Blockchain & Crypto' subtitle='NFT games and decentralized gaming platforms.' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='150' md='80' />
    </>
  )
}
